document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[dataBuilderRoot]');
  if (!root) return;
  const form = root.querySelector('[dataProductForm]');
  if (!form) return;

  const variantData = JSON.parse(root.querySelector('[dataVariantJson]').textContent);
  const moneyFormat = JSON.parse(root.querySelector('[dataMoneyFormat]').textContent);
  const variantInput = root.querySelector('[dataVariantInput]');
  const price = root.querySelector('[dataPrice]');
  const stock = root.querySelector('[dataStock]');
  const addButton = root.querySelector('[dataAddButton]');
  const stage = root.querySelector('[dataShirtStage]');
  const frontPreview = root.querySelector('[dataFrontPreview]');
  const backPreview = root.querySelector('[dataBackPreview]');
  const frontZone = root.querySelector('[dataFrontZone]');
  const backZone = root.querySelector('[dataBackZone]');
  const previewLabel = root.querySelector('[dataPreviewLabel]');

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function selectedOptions() {
    return [...root.querySelectorAll('[dataProductOption]')].map(group => {
      const checked = group.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function updateVariant() {
    const options = selectedOptions();
    const variant = variantData.find(v => v.options.every((value, index) => value === options[index]));
    if (!variant) {
      addButton.disabled = true;
      stock.textContent = 'Unavailable';
      return;
    }
    variantInput.value = variant.id;
    price.textContent = formatMoney(variant.price);
    addButton.disabled = !variant.available;
    stock.textContent = variant.available ? 'In stock' : 'Sold out';

    const groups = [...root.querySelectorAll('[dataProductOption]')];
    groups.forEach(group => {
      if ((group.dataset.optionName || '').toLowerCase().includes('color')) {
        const checked = group.querySelector('input:checked');
        const val = checked ? checked.value.toLowerCase() : '';
        if (val.includes('red')) stage.style.setProperty('--shirt', '#b51f2e');
        else if (val.includes('white')) stage.style.setProperty('--shirt', '#f2f2f2');
        else if (val.includes('gray') || val.includes('grey')) stage.style.setProperty('--shirt', '#777');
        else stage.style.setProperty('--shirt', '#101010');
      }
    });
  }

  root.querySelectorAll('[dataProductOption] input').forEach(input => input.addEventListener('change', updateVariant));

  root.querySelectorAll('[dataArtChoice]').forEach(input => {
    input.addEventListener('change', () => {
      const side = input.dataset.side;
      root.querySelectorAll(`[dataArtChoice][dataSide="${side}"]`).forEach(other => other.closest('.artChoice').classList.remove('isSelected'));
      input.closest('.artChoice').classList.add('isSelected');
      if (side === 'front') frontPreview.src = input.dataset.preview;
      if (side === 'back') backPreview.src = input.dataset.preview;
    });
  });

  root.querySelectorAll('[dataView]').forEach(button => {
    button.addEventListener('click', () => {
      root.querySelectorAll('[dataView]').forEach(b => b.classList.remove('isActive'));
      button.classList.add('isActive');
      const front = button.dataset.view === 'front';
      frontZone.classList.toggle('isVisible', front);
      backZone.classList.toggle('isVisible', !front);
      previewLabel.textContent = front ? 'Front preview' : 'Back preview';
    });
  });

  updateVariant();
});

// v12 homepage collection, search, and sorting controls
(function(){
  function initHomeShop(){
    const root=document.querySelector('[data-home-shop]');
    if(!root) return;
    const grid=root.querySelector('[data-product-grid]');
    const cards=[...root.querySelectorAll('[data-product-card]')];
    const tabs=[...root.querySelectorAll('[data-collection-filter]')];
    const search=root.querySelector('[data-shop-search]');
    const sort=root.querySelector('[data-shop-sort]');
    const count=root.querySelector('[data-result-count]');
    const empty=root.querySelector('[data-no-results]');
    let active='all';
    const original=new Map(cards.map((card,index)=>[card,index]));

    function render(){
      const q=(search?.value||'').trim().toLowerCase();
      cards.forEach(card=>{
        const collections=(card.dataset.collections||'').split(/\s+/).filter(Boolean);
        const matchesCollection=active==='all'||collections.includes(active);
        const matchesSearch=!q||(card.dataset.title||'').includes(q);
        card.hidden=!(matchesCollection&&matchesSearch);
      });
      const visible=cards.filter(card=>!card.hidden);
      const mode=sort?.value||'featured';
      visible.sort((a,b)=>{
        if(mode==='title-asc') return (a.dataset.title||'').localeCompare(b.dataset.title||'');
        if(mode==='price-asc') return Number(a.dataset.price||0)-Number(b.dataset.price||0);
        if(mode==='price-desc') return Number(b.dataset.price||0)-Number(a.dataset.price||0);
        return original.get(a)-original.get(b);
      }).forEach(card=>grid.appendChild(card));
      if(count) count.textContent=`${visible.length} product${visible.length===1?'':'s'}`;
      if(empty) empty.hidden=visible.length!==0;
    }

    tabs.forEach(tab=>tab.addEventListener('click',()=>{
      active=tab.dataset.collectionFilter||'all';
      tabs.forEach(t=>t.classList.toggle('isActive',t===tab));
      render();
    }));
    search?.addEventListener('input',render);
    sort?.addEventListener('change',render);
    render();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initHomeShop); else initHomeShop();
})();
